import React from 'react';
import { X, Check, AlertCircle } from 'lucide-react';
import { useWebhookLogs } from '../../../hooks';

export default function WebhookLogsModal({ webhook, onClose }) {
  const { data, isLoading } = useWebhookLogs(webhook.id);
  const logs = data?.items || [];

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  return (
    <div className="workbench-modal-overlay" onClick={onClose}>
      <div className="workbench-modal workbench-modal-wide" onClick={(e) => e.stopPropagation()}>
        <div className="workbench-modal-header">
          <h2>Delivery Logs - {webhook.name}</h2>
          <button className="workbench-modal-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="workbench-modal-body">
          {isLoading ? (
            <div className="workbench-loading">
              <div className="workbench-spinner" />
            </div>
          ) : logs.length === 0 ? (
            <div className="workbench-empty-sm">No delivery logs yet</div>
          ) : (
            <table className="workbench-table">
              <thead>
                <tr>
                  <th>Event</th>
                  <th>Status</th>
                  <th>Response</th>
                  <th>Time</th>
                  <th>Delivered</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td><code className="workbench-code-inline">{log.event_type}</code></td>
                    <td>
                      <span className={`log-status ${log.success ? 'success' : 'failed'}`}>
                        {log.success ? <Check size={14} /> : <AlertCircle size={14} />}
                        {log.success ? 'Success' : 'Failed'}
                      </span>
                    </td>
                    <td>{log.response_code || '-'}</td>
                    <td>{log.response_time_ms ? `${log.response_time_ms}ms` : '-'}</td>
                    <td>{formatDate(log.delivered_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
